import { NavLink, useLocation } from "react-router-dom";
import { useEffect } from "react";
import JobZImage from "../../../common/jobz-img";
import { admin, adminRoute, publicUser } from "../../../../globals/route-names";
import { loadScript, setMenuActive } from "../../../../globals/constants";

const items = [
    { label: "Dashboard", icon: "fa fa-home", route: admin.DASHBOARD },
    { label: "Pending Jobs", icon: "fa fa-clipboard-check", route: admin.JOBS_PENDING },
    { label: "All Jobs", icon: "fa fa-suitcase", route: admin.JOBS_ALL },
    { label: "Users", icon: "fa fa-users", route: admin.USERS },
    { label: "Employers", icon: "fa fa-user-tie", route: admin.EMPLOYERS },
    { label: "Candidates", icon: "fa fa-user-graduate", route: admin.CANDIDATES },
    { label: "Companies", icon: "fa fa-building", route: admin.COMPANIES },
    { label: "Applications", icon: "fa fa-file-alt", route: admin.APPLICATIONS },
    { label: "Resumes", icon: "fa fa-id-card", route: admin.RESUMES },
    { label: "Analytics", icon: "fa fa-chart-line", route: admin.ANALYTICS },
    { label: "Media Library", icon: "fa fa-images", route: admin.MEDIA },
    { label: "Site Content", icon: "fa fa-edit", route: admin.SITE_CONTENT },
    { label: "Blog Posts", icon: "fa fa-blog", route: admin.BLOGS },
    { label: "Job Categories", icon: "fa fa-tags", route: admin.CATEGORIES },
    { label: "Updates", icon: "fa fa-sync-alt", route: admin.UPDATES },
    { label: "Settings", icon: "fa fa-cog", route: admin.SETTINGS },
    { label: "Support Tickets", icon: "fa fa-headset", route: admin.SUPPORT },
    { label: "Audit Logs", icon: "fa fa-history", route: admin.AUDIT_LOGS }
];

function AdminSidebarSection(props) {
    const currentpath = useLocation().pathname;

    useEffect(() => {
        loadScript("js/custom.js");
        loadScript("js/emp-sidebar.js");
    });

    return (
        <nav id="sidebar-admin-wraper" className={props.sidebarActive ? "" : "active"}>
            <div className="page-logo">
                <NavLink to={publicUser.HOME1}><JobZImage id="skin_page_logo" src="images/zozojobs-logo.png" alt="Zozo Jobs" /></NavLink>
            </div>
            <div className="admin-nav scrollbar-macosx">
                <ul>
                    {items.map((item) => (
                        <li key={item.route} className={setMenuActive(currentpath, adminRoute(item.route))}>
                            <NavLink to={adminRoute(item.route)}>
                                <i className={item.icon} />
                                <span className="admin-nav-text">{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                    <li>
                        <button type="button" className="btn w-100 text-start" data-bs-toggle="modal" data-bs-target="#logout-dash-profile">
                            <i className="fa fa-share-square" />
                            <span className="admin-nav-text">Logout</span>
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default AdminSidebarSection;
